import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { Checkbox, FormControlLabel, FormHelperText, Box } from '@mui/material';

interface CheckboxWrapperProps {
  name: string;
  control: Control<any>;
  label: React.ReactNode;
  errorMessage?: string;
}

export const CheckboxWrapper: React.FC<CheckboxWrapperProps> = ({
  name,
  control,
  label,
  errorMessage,
}) => (
  <Box sx={{ marginTop: '-16px', marginLeft: '-9px' }}>
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <FormControlLabel
          control={
            <Checkbox checked={value || false} onChange={(e) => onChange(e.target.checked)} />
          }
          label={label}
          sx={{
            alignItems: 'center',
            margin: 0,
            '& .MuiFormControlLabel-label': {
              fontSize: '14px',
              lineHeight: '20px',
              marginTop: '4px',
            },
          }}
        />
      )}
    />
    {errorMessage && (
      <FormHelperText error sx={{ ml: '10px', mt: 0.5 }}>
        {errorMessage}
      </FormHelperText>
    )}
  </Box>
);
